import { request } from "apis/base";
import { CommonParamsType } from "constants/types/common";
import { RegionRequestBodyType, RegionUpdateBodyType } from "constants/types/region";

export const regionApi = {
  getAll: (params?: CommonParamsType) => {
    return request({ url: "/region", method: "GET", params });
  },

  getById: (id: string) => {
    return request({ url: `/region/${id}`, method: "GET" });
  },

  create: (data: RegionRequestBodyType) => {
    return request({ url: "/region", method: "POST", data });
  },

  update: (id: string, data: RegionUpdateBodyType) => {
    return request({ url: `/region/${id}`, method: "PUT", data });
  },

  delete: (id: string) => {
    return request({ url: `/region/${id}`, method: "DELETE" });
  },
};
